
function handleGiftsInCN(giftProducts) {
  function mergeObj(arr, groupBy, addBy) {
    const mapp = {};
  
    for (const obj of arr) {
      const key = obj[groupBy];
      const vall = obj[addBy];
  
      if (mapp[key]) {
        mapp[key][addBy] += vall;
      } else {
        mapp[key] = { [groupBy]: key, [addBy]: vall };
      }
    }
  
    return Object.values(mapp);
  }
  // fetch the cart and get current items
  fetch(`${routes.cart_url}.js`)
  .then((response) => response.json())
  .then((data) => {
    var cartItems = data.items;
    console.log(cartItems);
    if(cartItems.length > 0){
      let cartItemsObject = [];
      var atcObject = {items: []};
      var atcObjectDiff = {items: []};
      var alreadyInObject = {items: []};
      var atcObject1 = {items: []};
      var atcObjectDiff1 = {items: []};
      var alreadyInObject1 = {items: []};
      for(var i=0; i< cartItems.length; i++ ){
        cartItemsObject.push({ id : cartItems[i].product_id, qty : cartItems[i].quantity, id_var: cartItems[i].id });
      };
      console.log(cartItemsObject);
      
      // check product ids with collections ids

      

      for(let k=0;k<cartItemsObject.length;k++) {
        for(let j=0;j<giftProducts.items.length;j++) {
          for(let m=0;m<giftProducts.items[j].ids.length;m++) {
            if(giftProducts.items[j].ids[m] == cartItemsObject[k].id){
              atcObject.items.push({ id: giftProducts.items[j].gift , quantity: cartItemsObject[k].qty });
              atcObjectDiff.items.push({ id: giftProducts.items[j].gift , quantity: cartItemsObject[k].qty });
            }
          }
        }
      }
      atcObject1.items = mergeObj(atcObject.items,"id","quantity");
      atcObjectDiff1.items = mergeObj(atcObjectDiff.items,"id","quantity");
      console.log("ATC: ", atcObject1);

      for(let k=0;k<cartItemsObject.length;k++) {
        for(let j=0;j<giftProducts.items.length;j++) {
          if(giftProducts.items[j].gift == cartItemsObject[k].id_var){
            alreadyInObject.items.push({ id: giftProducts.items[j].gift , quantity: cartItemsObject[k].qty });
          }
        }
      }
      alreadyInObject1.items = mergeObj(alreadyInObject.items,"id","quantity");
      console.log("Already in: ", alreadyInObject);
      for(let k=0;k<alreadyInObject1.items.length;k++) {
        for(let j=0;j<atcObjectDiff1.items.length;j++) {
          if(atcObjectDiff1.items[j].id == alreadyInObject1.items[k].id){
            if((atcObjectDiff1.items[j].quantity - alreadyInObject1.items[k].quantity > 0)){
              atcObjectDiff1.items[j].quantity = atcObjectDiff1.items[j].quantity - alreadyInObject1.items[k].quantity;
            }
            else {
              atcObjectDiff1.items[j].quantity = 0;
            }
          }
        }
      }
      
      console.log("Difference: ", atcObjectDiff1);
      // compare with already present gifts
      
      // add to cart
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(atcObjectDiff1)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  })
  .catch((e) => {
    console.error(e);
  });
}



class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
    var giftProductsCN = window.free_giftCN;
    if(window.free_giftCN.enable){
    handleGiftsInCN(giftProductsCN);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
